import InputFilterController from "../input_filter_controller.js"

// This controller inheirits from InputFilterController to avoid namespacing/conflict concerns
//
// Connects to data-controller="input-filter"
export default class extends InputFilterController {
}
